import { View, Text, FlatList, TouchableOpacity, StyleSheet, ActivityIndicator } from 'react-native';
import { useLocalSearchParams, useRouter, useNavigation } from 'expo-router';
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { WorkoutPlan } from '@/lib/types';

interface RoutineRow {
  id: string;
  student_id: string;
  name: string;
  start_date: string | null;
  end_date: string | null;
}

export default function RoutineDetailScreen() {
  const { routineId } = useLocalSearchParams<{ routineId: string }>();
  const router = useRouter();
  const navigation = useNavigation();
  const [routine, setRoutine] = useState<RoutineRow | null>(null);
  const [plans, setPlans] = useState<WorkoutPlan[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const { data: routineData } = await supabase
        .from('workout_routines').select('*').eq('id', routineId).single();
      if (!routineData) { setLoading(false); return; }
      setRoutine(routineData as RoutineRow);
      navigation.setOptions({ title: routineData.name });
      const { data: planData } = await supabase
        .from('workout_plans').select('*').eq('routine_id', routineId).order('created_at');
      if (planData) setPlans(planData as WorkoutPlan[]);
      setLoading(false);
    }
    load().catch(() => setLoading(false));
  }, [routineId]);

  if (loading) return <ActivityIndicator style={{ flex: 1 }} color="#C8102E" />;
  if (!routine) return <Text style={{ margin: 20 }}>Rotina não encontrada.</Text>;

  return (
    <View style={styles.container}>
      <View style={styles.routineHeader}>
        <Text style={styles.routineName}>{routine.name}</Text>
        {(routine.start_date || routine.end_date) && (
          <Text style={styles.routineDates}>
            {routine.start_date ?? '?'} – {routine.end_date ?? '?'}
          </Text>
        )}
      </View>
      <FlatList
        data={plans}
        keyExtractor={p => p.id}
        contentContainerStyle={{ padding: 16, gap: 10 }}
        renderItem={({ item }) => (
          <TouchableOpacity style={styles.planCard} onPress={() => router.push(`/(personal)/plans/${item.id}` as any)}>
            <Text style={styles.planName}>{item.name}</Text>
            <Text style={styles.planAction}>Ver exercícios →</Text>
          </TouchableOpacity>
        )}
        ListEmptyComponent={<Text style={styles.empty}>Nenhuma ficha nessa rotina ainda.</Text>}
        ListFooterComponent={
          <TouchableOpacity
            style={styles.addBtn}
            onPress={() => router.push(`/(personal)/plans/new?studentId=${routine.student_id}&routineId=${routineId}` as any)}
          >
            <Text style={styles.addBtnText}>+ Novo Treino</Text>
          </TouchableOpacity>
        }
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  routineHeader: { padding: 20, borderBottomWidth: 1, borderBottomColor: '#eee' },
  routineName: { fontSize: 20, fontWeight: 'bold', color: '#1A1A1A' },
  routineDates: { fontSize: 13, color: '#888', marginTop: 4 },
  planCard: { backgroundColor: '#F5F5F5', padding: 16, borderRadius: 10 },
  planName: { fontSize: 15, fontWeight: '600', color: '#1A1A1A' },
  planAction: { fontSize: 13, color: '#C8102E', marginTop: 4 },
  empty: { textAlign: 'center', color: '#aaa', marginTop: 20 },
  addBtn: { backgroundColor: '#C8102E', padding: 16, borderRadius: 10, alignItems: 'center', marginTop: 16 },
  addBtnText: { color: '#fff', fontWeight: 'bold', fontSize: 15 },
});
